import styled from "@emotion/styled";

export default styled.div`
  display: flex;
  gap: 80px;
  padding: 20px;

  .card-title {
    font-size: 18px;
    font-weight: 600;
    margin-bottom: 20px;
    color: #374151;
  }

  .border {
    border: 1px solid #e5e7eb !important;
    border-radius: 12px !important;
    padding: 16px !important;
    padding-top: 8px !important;
    padding-bottom: 8px !important;
  }

  .billing-section {
    background: white;
    border-radius: 12px;
    padding: 32px;
    position: relative;
    flex-grow: 1;
  }

  .billing-card {
    background: transparent;
    border: none;
    border-radius: 0;
    padding: 0;
    margin-bottom: 32px;

    &:last-of-type {
      margin-bottom: 0;
    }
  }

  .plan-title-container {
    display: flex;
    align-items: center;
    justify-content: space-between;
    width: 100%;

    .plan-title {
      font-size: 18px;
      font-weight: 600;
      color: #374151;
    }

    .plan-badges {
      display: inline-flex;
      align-items: center;
      gap: 8px;
      margin-left: 16px;
    }

    .free-tier-badge {
      background: #f0fdf4;
      color: #16a34a;
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 500;
      border: 1px solid #bbf7d0;
    }

    .unsubscribed-badge {
      background: #fee2e2;
      color: #b91c1c;
      padding: 4px 10px;
      border-radius: 6px;
      font-size: 12px;
      font-weight: 600;
      border: 1px solid #fecaca;
      text-transform: none;
    }
  }

  .stats-grid {
    display: grid;
    grid-template-columns: repeat(3, 1fr);
    gap: 32px;
    margin-bottom: 48px;
  }

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: flex-start;
    margin-top: 16px;
    padding: 20px 16px;
    border-radius: 12px;
    border: 1px solid #e5e7eb;
    gap: 12px;
    position: relative;
    text-align: left;

    .stat-icon {
      width: 48px;
      height: 48px;
      border-radius: 12px;
      display: flex;
      align-items: center;
      justify-content: center;
      font-size: 24px;

      &.athletes {
        background: #8b5cf6;
        color: white;
      }

      &.analyses {
        background: #f97316;
        color: white;
      }

      &.cost {
        background: #eab308;
        color: white;
      }
    }

    .stat-content {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      gap: 4px;

      .stat-label {
        font-size: 13px;
        color: #6b7280;
        margin-bottom: 0;
        font-weight: 500;
      }

      .stat-value {
        font-size: 20px;
        font-weight: 700;
        color: #111827;
        line-height: 1.2;
      }
    }

    .upgrade-link {
      position: absolute;
      top: 16px;
      right: 16px;
      background: transparent;
      color: #05b2dc;
      padding: 0;
      border: none;
      text-decoration: none;
      font-size: 14px;
      font-weight: 600;
      transition: color 0.2s ease;
      white-space: nowrap;
      cursor: pointer;

      &:hover {
        cursor: pointer;
      }

      &:focus {
        outline: 2px solid #60a5fa;
        outline-offset: 2px;
        text-decoration: underline;
      }
    }
  }

  .payment-method-content {
    display: flex;
    align-items: center;
    justify-content: space-between;

    .payment-info {
      display: flex;
      align-items: center;
      gap: 16px;

      .payment-icon {
        width: 48px;
        height: 48px;
        background: #635bff;
        border-radius: 12px;
        display: flex;
        align-items: center;
        justify-content: center;
        color: white;
        font-weight: 700;
        font-size: 20px;
      }

      .payment-text {
        font-size: 18px;
        font-weight: 600;
        color: #111827;
      }
    }

    .status-badge {
      background: #10b981;
      color: white;
      padding: 8px 16px;
      border-radius: 8px;
      font-size: 13px;
      font-weight: 600;
    }
  }
  .invoice-list {
    display: flex;
    flex-direction: column;
    gap: 4px;
  }

  .payment-history-header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    gap: 16px;

    .export-link {
      color: #05b2dc;
      text-decoration: none;
      font-size: 14px;
      font-weight: 500;

      &:hover {
        text-decoration: underline;
      }
    }
  }

  .invoice-item {
    display: flex;
    align-items: center;
    justify-content: space-between;
    padding: 20px 0;
    border-bottom: 1px solid #f3f4f6;

    &:last-child {
      border-bottom: none;
    }

    .invoice-info {
      display: flex;
      align-items: center;
      gap: 16px;

      .invoice-details {
        .invoice-id {
          font-weight: 600;
          color: #111827;
          margin-bottom: 4px;
          font-size: 15px;
        }

        .invoice-date {
          font-size: 13px;
          color: #6b7280;
          font-weight: 500;
        }
      }
    }

    .invoice-right {
      display: flex;
      align-items: center;
      gap: 20px;

      .invoice-amount {
        font-weight: 700;
        color: #111827;
        font-size: 18px;
      }

      .invoice-status {
        padding: 6px 12px;
        border-radius: 6px;
        font-size: 12px;
        font-weight: 600;
        text-transform: capitalize;

        &.succeeded {
          background: #d1fae5;
          color: #065f46;
        }

        &.pending {
          background: #fef3c7;
          color: #92400e;
        }

        &.failed {
          background: #fee2e2;
          color: #991b1b;
        }
      }

      .download-link {
        color: #05b2dc;
        text-decoration: none;
        font-size: 14px;
        font-weight: 500;

        &:hover {
          text-decoration: underline;
        }
      }
    }
  }
`;
